import { Nullable } from 'primereact/ts-helpers';
import { createContext } from 'react';

export interface AuthContextProps {
  token: Nullable<string>
  isAuthenticated: boolean
  setToken: React.Dispatch<React.SetStateAction<Nullable<string>>>
  signOut: () => void
}

export const AuthContext = createContext<AuthContextProps>({
  token: null,
  isAuthenticated: false,
  setToken: () => {},
  signOut: () => {},
});
